import { ISolutionFeatureFragment } from 'src/graphql/generated/hooks'
import { FeaturesType, SectionItem } from 'src/types'

import { apolloSdk } from '../graphql/apolloSdk'
import { checkNotEmpty } from './checkNotEmpty'

export const getFeaturesItems = (subTopics: any[], solutionFeatures: any[]) => {
  const featuresItems: SectionItem[] = []
  subTopics.map((subTopic) => {
    const features = subTopic?.features || []
    if (checkNotEmpty(features)) {
      const convertedItems: FeaturesType[] = features.map((item: any) => {
        const converted: FeaturesType = {
          name: item?.name || '',
          isChecked: solutionFeatures.filter((feature) => item?.name === feature?.name).length > 0,
        }
        return converted
      })
      convertedItems.sort((a) => (a.isChecked ? 1 : 0))

      featuresItems.push({
        title: `${subTopic?.name || ''} Key Features`,
        type: 'CheckDataList',
        subType: 'cart',
        items: convertedItems,
        isFullWidth: true,
      })
    }
  })

  return featuresItems
}

export const getFeaturesCheckedItem = async (solutionFeatures: ISolutionFeatureFragment[]) => {
  const features = await apolloSdk.allFeatures()
  const allFeatures = features.features || []
  const featuresItems: SectionItem[] = []
  if (checkNotEmpty(allFeatures)) {
    const convertedItems: FeaturesType[] = allFeatures.map((feat) => {
      const currentName = feat?.name
      const converted: FeaturesType = {
        name: currentName || '',
        isChecked: solutionFeatures.filter((feature) => currentName === feature?.name).length > 0,
      }
      return converted
    })
    convertedItems.sort((a) => (a.isChecked ? 1 : 0))
    featuresItems.push({
      title: 'OPTIONAL SUBHEADER',
      type: 'CheckDataList',
      subType: 'cart',
      items: convertedItems,
      isFullWidth: true,
      colValue: 2,
    })
  }
  return featuresItems
}
